import 'css-chunksrc/dev-tools/EPXTool.module.scss';export default {
  "root": "EPXTool_root",
  "response": "EPXTool_response",
  "json-view-wrapper": "EPXTool_json-view-wrapper"
};